<template>
  <div class="revenue-dashboard">
    <!-- KPI Cards -->
    <revenue-card :item="kpiCards" />

    <!-- Needs Attention + Live Throughput -->
    <div class="dashboard-sections">
      <!-- Needs Attention -->
      <v-card class="dashboard-card">
        <v-card-text>
          <div class="section-title">
            <span>Needs attention</span>
            <span class="count-badge">5</span>
          </div>

          <div
            v-for="(item, index) in attentionItems"
            :key="index"
            class="attention-item"
          >
            <div
              class="status-dot"
              :class="`status-${item.status}`"
            />

            <div class="attention-content">
              <div class="attention-header">
                <div>
                  <span class="attention-title">
                    {{ item.title }}
                  </span>

                  <span class="attention-location">
                    · {{ item.location }}
                  </span>
                </div>

                <span class="attention-time">
                  {{ item.time }}
                </span>
              </div>

              <div class="attention-description">
                {{ item.description }}
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- Live Throughput -->
      <v-card class="dashboard-card">
        <v-card-text>
          <div class="section-title">
            Live throughput
          </div>

          <div
            v-for="(item, index) in throughputItems"
            :key="index"
            class="throughput-item"
          >
            <span class="throughput-label">
              {{ item.label }}
            </span>

            <span class="throughput-value">
              {{ item.value }}
              <small v-if="item.unit">
                {{ item.unit }}
              </small>
            </span>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- Availability by site — worst first -->
    <v-card class="dashboard-card site-card">
      <v-card-text>
        <div class="section-title">
          Availability by site — worst first
        </div>

        <div class="site-table">
          <div class="site-table-header">
            <span class="col-site">SITE</span>
            <span class="col-avail">AVAIL</span>
            <span class="col-faults">FAULTS</span>
            <span class="col-trend">TREND</span>
          </div>

          <div
            v-for="(item, index) in siteAvailabilityItems"
            :key="index"
            class="site-table-row"
          >
            <div class="col-site">
              <div class="site-name">
                {{ item.site }}
              </div>
              <div class="site-location">
                {{ item.location }}
              </div>
            </div>

            <div
              class="col-avail"
              :class="item.availStatus"
            >
              {{ item.avail }}
            </div>

            <div
              class="col-faults"
              :class="item.faultsStatus"
            >
              {{ item.faults }}
            </div>

            <div class="col-trend">
              <svg
                class="sparkline"
                viewBox="0 0 200 30"
                preserveAspectRatio="none"
              >
                <path
                  :d="item.trendPath"
                  :stroke="item.trendColor"
                  stroke-width="2"
                  fill="none"
                  stroke-linecap="round"
                />
                <circle
                  :cx="item.dotX"
                  :cy="item.dotY"
                  r="4"
                  :fill="item.trendColor"
                />
              </svg>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    RevenueCard: () => import("../utils/RevenueCards.vue"),
  },

  data() {
    return {
      kpiCards: [
        {
          title: "Charger Availability",
          status: "breached",
          value: 38.75,
          unit: "%",
          text: "Target 98%",
          progress: 50,
        },
        {
          title: "Open Faults",
          status: "breached",
          value: 153,
          unit: "",
          text: "Target 0 - 153 open",
          progress: 35,
        },
        {
          title: "First-time Charge Success",
          status: "breached",
          value: 34.71,
          unit: "%",
          text: "Target 95%",
          progress: 80,
        },
        {
          title: "Mean Time To Repair",
          status: "at risk",
          value: 4.2,
          unit: "h",
          text: "Target 4h",
          progress: 100,
        },
      ],

      attentionItems: [
        {
          title: "F-7 Markaz",
          location: "Islamabad",
          description: "Availability 41% — SLA is 98%",
          time: "today",
          status: "red",
        },
        {
          title: "Clifton Block 5",
          location: "Karachi",
          description: "3 connectors offline",
          time: "2h 40m",
          status: "red",
        },
        {
          title: "Blue Area",
          location: "Islamabad",
          description: "Charger unreachable — comms fault",
          time: "55m",
          status: "red",
        },
        {
          title: "DHA Phase 6",
          location: "Karachi",
          description: "Ground fault cleared — monitoring",
          time: "20m",
          status: "yellow",
        },
        {
          title: "G-9 Markaz",
          location: "Islamabad",
          description: "Elevated MTTR on 2 units",
          time: "today",
          status: "yellow",
        },
      ],

      throughputItems: [
        {
          label: "Active sessions",
          value: 2,
          unit: "",
          type: "green",
        },
        {
          label: "Sessions today",
          value: 42,
          unit: "",
        },
        {
          label: "Energy dispensed",
          value: "907.86",
          unit: "kWh",
        },
        {
          label: "Revenue today",
          value: "Rs 110,685.87",
          unit: "",
        },
        {
          label: "Avg charge / session",
          value: "49.1",
          unit: "%",
        },
        {
          label: "New users",
          value: 42,
          unit: "",
        },
      ],

      siteAvailabilityItems: [
        {
          site: "F-7 Markaz",
          location: "Islamabad",
          avail: "41%",
          faults: 22,
          availStatus: "status-text-red",
          faultsStatus: "status-text-red",
          trendColor: "#ff6b72",
          trendPath: "M 0 8 Q 100 15 200 20",
          dotX: 200,
          dotY: 20,
        },
        {
          site: "Clifton Block 5",
          location: "Karachi",
          avail: "44%",
          faults: 31,
          availStatus: "status-text-red",
          faultsStatus: "status-text-red",
          trendColor: "#ff6b72",
          trendPath: "M 0 5 Q 100 12 200 18",
          dotX: 200,
          dotY: 18,
        },
        {
          site: "Blue Area",
          location: "Islamabad",
          avail: "48%",
          faults: 18,
          availStatus: "status-text-red",
          faultsStatus: "status-text-red",
          trendColor: "#ff6b72",
          trendPath: "M 0 6 Q 100 16 200 22",
          dotX: 200,
          dotY: 22,
        },
        {
          site: "DHA Phase 6",
          location: "Karachi",
          avail: "63%",
          faults: 11,
          availStatus: "status-text-red",
          faultsStatus: "",
          trendColor: "#ff6b72",
          trendPath: "M 0 5 Q 120 22 200 18",
          dotX: 200,
          dotY: 18,
        },
        {
          site: "G-11 Markaz",
          location: "Islamabad",
          avail: "81%",
          faults: 5,
          availStatus: "status-text-yellow",
          faultsStatus: "",
          trendColor: "#ffc21c",
          trendPath: "M 0 25 Q 100 12 200 15",
          dotX: 200,
          dotY: 15,
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>

.revenue-dashboard
  width: 100%

.dashboard-sections
  display: grid
  grid-template-columns: 1fr 0.86fr
  gap: 1rem
  margin-top: 1rem

.dashboard-card
  border-radius: 16px !important
  overflow: hidden

.section-title
  display: flex
  align-items: center
  gap: 10px
  font-size: 16px
  font-weight: 600
  margin-bottom: 1rem

.count-badge
  display: inline-flex
  align-items: center
  justify-content: center
  min-width: 25px
  height: 25px
  padding: 0 7px
  border-radius: 20px
  background: #ef6b72
  color: white
  font-size: 12px
  font-weight: 600

.attention-item
  display: flex
  align-items: flex-start
  gap: 15px
  padding: 16px 0
  border-bottom: 1px solid rgba(255, 255, 255, 0.08)

  &:last-child
    border-bottom: none
    padding-bottom: 0

.status-dot
  width: 11px
  height: 11px
  min-width: 11px
  margin-top: 5px
  border-radius: 50%

.status-red
  background: #ff6b72

.status-yellow
  background: #ffc21c

.attention-content
  width: 100%

.attention-header
  display: flex
  justify-content: space-between
  align-items: center
  gap: 10px

.attention-title
  font-size: 15px
  font-weight: 600

.attention-location
  color: #7182a3
  font-size: 13px

.attention-time
  color: #7182a3
  font-size: 12px
  white-space: nowrap

.attention-description
  margin-top: 5px
  color: #91a1c0
  font-size: 13px

.throughput-item
  display: flex
  justify-content: space-between
  align-items: center
  min-height: 47px
  border-bottom: 1px solid rgba(255, 255, 255, 0.08)

  &:last-child
    border-bottom: none

.throughput-label
  font-size: 14px

.throughput-value
  font-size: 14px
  font-weight: 600
  text-align: right

  small
    margin-left: 5px
    color: #91a1c0
    font-size: 11px
    font-weight: 400

/* Availability By Site Table */
.site-card
  margin-top: 1rem

.site-table
  width: 100%

.site-table-header,
.site-table-row
  display: grid
  grid-template-columns: 2fr 1fr 1fr 2.5fr
  align-items: center
  padding: 12px 0

.site-table-header
  font-size: 11px
  font-weight: 600
  color: #7182a3
  letter-spacing: 0.5px
  border-bottom: 1px solid rgba(255, 255, 255, 0.08)

.site-table-row
  border-bottom: 1px solid rgba(255, 255, 255, 0.08)

  &:last-child
    border-bottom: none
    padding-bottom: 0

.site-name
  font-size: 15px
  font-weight: 600

.site-location
  font-size: 12px
  color: #7182a3
  margin-top: 2px

.col-avail,
.col-faults
  font-size: 14px
  font-weight: 600

.status-text-red
  color: #ff6b72

.status-text-yellow
  color: #ffc21c

.col-trend
  padding-left: 1rem

.sparkline
  width: 100%
  height: 28px
  overflow: visible

@media (max-width: 1024px)
  .dashboard-sections
    grid-template-columns: 1fr

@media (max-width: 600px)
  .dashboard-sections
    grid-template-columns: 1fr
    gap: 12px

  .dashboard-card
    border-radius: 12px !important

  .attention-header
    align-items: flex-start

  .attention-title
    font-size: 14px

  .attention-location
    font-size: 12px

  .attention-description
    font-size: 12px

  .throughput-label,
  .throughput-value
    font-size: 13px

  .site-table-header,
  .site-table-row
    grid-template-columns: 1.5fr 1fr 1fr 1.5fr

  .site-name
    font-size: 13px

  .col-avail,
  .col-faults
    font-size: 13px
</style>
